import classNames from 'classnames';
import type { HTMLAttributes, ReactNode } from 'react';

import styles from './navigation-button.module.css';

interface NavigationButtonProps
  extends Omit<HTMLAttributes<HTMLButtonElement>, 'slot'> {
  slot?: ReactNode;
  isSelected: boolean;
  size?: 'sm' | 'md';
  alwaysShowSlot?: boolean;
}

/**
Used for side navigation, and various menu navigation requiring buttons.
See Figma: https://www.figma.com/design/OuKG28K37tcn264V957VTU/Design-System?node-id=668-4003&t=UOzImQ0uFeID045i-0
**/
export const NavigationButton = ({
  slot,
  className,
  children,
  isSelected,
  size = 'md',
  alwaysShowSlot = true,
  ...rest
}: NavigationButtonProps) => {
  return (
    <div
      className={classNames(
        styles.navigationButtonContainer,
        isSelected && styles.navigationButtonSelected,
        !alwaysShowSlot && styles.navigationButtonContainerHiddenSlot
      )}
      data-selected={isSelected}
    >
      <button
        data-show-slot={alwaysShowSlot}
        className={classNames(
          styles.navigationButton,
          size === 'sm' && styles.navigationButtonSmall,
          className
        )}
        data-selected={isSelected}
        {...rest}
      >
        <div>{children}</div>
      </button>

      {slot && <div className={styles.slotContainer}>{slot}</div>}
    </div>
  );
};
